import React from "react";
import { sortBy } from "lodash";
import { Field, reduxForm } from "redux-form";
import { FormGroup, Row, Col } from "react-bootstrap";
import Button from "../elements/CustomButton/CustomButton";

import { renderField, renderSelect } from "./_fieldRenderer";
import { db } from "../services/firebase";
import "./forms.css";

const validate = (values) => {
  const errors = {};
  if (!values.places) {
    errors.places = "Obrigatório";
  }
  if (!values.name) {
    errors.name = "Obrigatório";
  }
  return errors;
};

class LineForm extends React.Component {
  constructor(props) {
    super(props);
    this.companyID = props.companyID;
    this.state = {
      places: [],
      fetchingPlaces: false,
    };
  }

  componentDidMount() {
    const places = [];
    this.setState({ fetchingPlaces: true });
    db.collection("companies")
      .doc(this.props.companyID)
      .collection("places")
      .get()
      .then((placeSnapshot) => {
        if (!placeSnapshot.empty) {
          placeSnapshot.forEach((place) =>
            places.push({
              value: place.id,
              label: `${place.data().name}`,
            })
          );
          this.setState({ fetchingPlaces: false, places });
        } else {
          this.setState({ fetchingPlaces: false, places });
        }
      });
  }

  render() {
    const { handleSubmit, submitting } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                name="name"
                type="text"
                component={renderField}
                label="Nome"
                placeholder="Nome"
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                name="places"
                component={renderSelect}
                label="Local"
                disabled={!this.state.places.length}
                placeholder={this._handlePlaceholder(this.state.places)(
                  this.state.fetchingPlaces
                )("male")}
                options={sortBy(this.state.places, ["label", "asc"])}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="form__actions_margin">
          <div className="form__actions_container">
            <Button
              style={{ width: "45%" }}
              bsStyle="danger"
              type="button"
              disabled={submitting}
              onClick={this._handleCancel}
              wd
            >
              Cancelar
            </Button>
            <Button
              style={{ width: "45%" }}
              bsStyle="default"
              type="submit"
              disabled={submitting}
              fill
            >
              Salvar
            </Button>
          </div>
        </Row>
      </form>
    );
  }

  //handlers
  _handleCancel = () => {
    this.props.reset(); //form reset - redux-form action creator
    this.props.handleCancel(); //function passed via props
  };

  _handlePlaceholder = (stateProperty) => (stateFetch) => (gender) => {
    if (stateFetch) {
      return "Aguarde";
    }

    if (!stateFetch && !stateProperty.length) {
      return `Nenhum${gender === "male" ? "" : "a"} cadastrad${
        gender === "male" ? "o" : "a"
      }`;
    }

    if (!stateFetch && stateProperty.length) {
      return "Selecione";
    }
  };
}

LineForm = reduxForm({ form: "LineForm", validate })(LineForm);
export default LineForm;



// WEBPACK FOOTER //
// ./src/forms/LineForm.jsx